__turbopack_context__.v({
  "bannerImage": "Wkb67q_bannerImage",
  "bottom0": "Wkb67q_bottom0",
  "bottom10": "Wkb67q_bottom10",
  "bottom12": "Wkb67q_bottom12",
  "bottom16": "Wkb67q_bottom16",
  "bottom2": "Wkb67q_bottom2",
  "bottom20": "Wkb67q_bottom20",
  "bottom24": "Wkb67q_bottom24",
  "bottom3": "Wkb67q_bottom3",
  "bottom4": "Wkb67q_bottom4",
  "bottom6": "Wkb67q_bottom6",
  "bottom8": "Wkb67q_bottom8",
  "bottomMobile0": "Wkb67q_bottomMobile0",
  "bottomMobile10": "Wkb67q_bottomMobile10",
  "bottomMobile12": "Wkb67q_bottomMobile12",
  "bottomMobile16": "Wkb67q_bottomMobile16",
  "bottomMobile2": "Wkb67q_bottomMobile2",
  "bottomMobile20": "Wkb67q_bottomMobile20",
  "bottomMobile24": "Wkb67q_bottomMobile24",
  "bottomMobile3": "Wkb67q_bottomMobile3",
  "bottomMobile4": "Wkb67q_bottomMobile4",
  "bottomMobile6": "Wkb67q_bottomMobile6",
  "bottomMobile8": "Wkb67q_bottomMobile8",
  "center": "Wkb67q_center",
  "condensed": "Wkb67q_condensed",
  "infoBox": "Wkb67q_infoBox",
  "mobilePadding": "Wkb67q_mobilePadding",
  "noDesktopPadding": "Wkb67q_noDesktopPadding",
  "noMobilePadding": "Wkb67q_noMobilePadding",
  "noTabletPadding": "Wkb67q_noTabletPadding",
  "pageTitle": "Wkb67q_pageTitle",
  "sectionContainer": "Wkb67q_sectionContainer",
  "sectionTitle": "Wkb67q_sectionTitle",
  "size-2xl": "Wkb67q_size-2xl",
  "size-3xl": "Wkb67q_size-3xl",
  "size-4xl": "Wkb67q_size-4xl",
  "size-base": "Wkb67q_size-base",
  "size-large": "Wkb67q_size-large",
  "size-micro": "Wkb67q_size-micro",
  "size-nano": "Wkb67q_size-nano",
  "size-small": "Wkb67q_size-small",
  "size-xl": "Wkb67q_size-xl",
  "tabletPadding": "Wkb67q_tabletPadding",
  "top0": "Wkb67q_top0",
  "top10": "Wkb67q_top10",
  "top12": "Wkb67q_top12",
  "top16": "Wkb67q_top16",
  "top2": "Wkb67q_top2",
  "top20": "Wkb67q_top20",
  "top24": "Wkb67q_top24",
  "top3": "Wkb67q_top3",
  "top4": "Wkb67q_top4",
  "top6": "Wkb67q_top6",
  "top8": "Wkb67q_top8",
  "topMobile0": "Wkb67q_topMobile0",
  "topMobile10": "Wkb67q_topMobile10",
  "topMobile12": "Wkb67q_topMobile12",
  "topMobile16": "Wkb67q_topMobile16",
  "topMobile2": "Wkb67q_topMobile2",
  "topMobile20": "Wkb67q_topMobile20",
  "topMobile24": "Wkb67q_topMobile24",
  "topMobile3": "Wkb67q_topMobile3",
  "topMobile4": "Wkb67q_topMobile4",
  "topMobile6": "Wkb67q_topMobile6",
  "topMobile8": "Wkb67q_topMobile8",
});
